export const BookingStatusEnum = {
  PENDING: 'PENDING', // 待確認
  CONFIRMED: 'CONFIRMED', // 已確認
  PAID: 'PAID', // 已付款/待報到
  UNPAID: 'UNPAID', // 未付款
  CHECK_IN: 'CHECK_IN', // 已報到
  NO_SHOW: 'NO_SHOW', // 未報到
  CANCEL: 'CANCEL', // 已取消
  CHECK_OUT: 'CHECK_OUT', // 已退房
}
